module.exports = __webpack_public_path__ + "static/media/al_di_la_logo.9f43cd47.svg";